import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Search from './Search';
import Profile from './Profile';

const Cabinet = () => {
    const refSearch = useRef<HTMLDivElement>(null);
    const refProfile = useRef<HTMLDivElement>(null);

    return (
		<div className='Cabinet'>
            <div ref={refSearch} className='Left'><Search refSearch={refSearch} refProfile={refProfile}/></div>
            <div ref={refProfile} className='Right'><Profile refSearch={refSearch} refProfile={refProfile}/></div>
            <Outlet/>
	    </div>
    );
};

export default Cabinet;
